import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyBKWH9GsKp8fw9qc4WPA5y_xS4YJAyWOxE',
  authDomain: 'twitter-clone-f567e.firebaseapp.com',
  databaseURL: 'https://twitter-clone-f567e.firebaseio.com',
  projectId: 'twitter-clone-f567e',
  storageBucket: 'twitter-clone-f567e.appspot.com',
  messagingSenderId: '514760003954',
  appId: '1:514760003954:web:2c60e18e6e18509f174deb',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
